import type {ReactElement} from 'react'

import {type InputType, TextInput} from '../TextInput'

const normalize = (value?: string) => {
  if (!value) return ''
  value = value.replace(/[^\d-]/g, '').replace(/(?!^)-/g, '')
  return value
}

// только целые числа
export function NumberInput({name, ...otherProps}: InputType): ReactElement {
  return <TextInput inputTransformationFunction={normalize} name={name} {...otherProps} />
}
